import React from 'react';

const GenderStep = ({ answers, setAnswers }) => {
  const handleSelect = (gender) => {
    setAnswers(prev => ({
      ...prev,
      gender
    }));
  };

  return (
    <div className="text-center">
      <h2 className="text-2xl font-bold mb-6 text-gray-800">لطفا جنسیت خود را انتخاب کنید</h2>
      <div className="grid grid-cols-2 gap-4">
        {['زن', 'مرد', 'سایر'].map((gender) => (
          <button
            key={gender}
            onClick={() => handleSelect(gender)}
            className={`w-full py-3 rounded-lg border-2 transition-all duration-200 focus:outline-none ${
              answers.gender === gender
                ? 'border-black bg-black text-white'
                : 'border-gray-300 hover:border-gray-400 hover:bg-gray-50'
            }`}
          >
            <span className="text-sm font-medium">{gender}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default GenderStep; 